exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.baseInfo[data-v-3188e87c] {\n  padding-top: 0.4rem;\n}\n.baseInfo .headdiv[data-v-3188e87c] {\n  height: 20.7rem;\n}\n.baseInfo[data-v-3188e87c]::before {\n  content: \"\";\n  width: 100%;\n  height: 2rem;\n  background-image: linear-gradient(180deg, #FFFFFF 0%, #F6F9F9 100%);\n  top: 0;\n  left: 0;\n  display: block;\n  position: absolute;\n  z-index: -1;\n}\n.baseInfo .info[data-v-3188e87c] {\n  border-radius: 0.4rem;\n}\n.baseInfo .info .title[data-v-3188e87c] {\n  height: 1.6rem;\n}", ""]);

// exports
